import { render, staticRenderFns } from "./RecipientView.vue?vue&type=template&id=2185833a"
import script from "./RecipientView.vue?vue&type=script&lang=js"
export * from "./RecipientView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports